<ul class="instance-menu">
  <li
    *ngFor="let item of items"
    (click)="
      item?.onClick({
        id: item.id,
        customerId: item.customerId,
        type: item.type,
        path: item.path
      })
    "
  >
    {{ item?.text }}
  </li>
</ul>
